"use client";

import * as React from "react";
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { IOperation } from "@/types/operation";
import { HeroOperation } from "./heroOperation";
import { RichTextOperation } from "../richText/operation";
import { PostSummary } from "../richText/summary";

export const OperationSingle = ({ entry }: { entry: IOperation }) => {
  // const data = useContentfulLiveUpdates(entry, { locale: "en" });
  const data = useContentfulLiveUpdates(entry, { locale: "fr" });
  if (!data || !entry) return null;
  return (
    <ContentfulLivePreviewProvider
      locale="fr"
      enableInspectorMode={true}
      enableLiveUpdates={true}
      debugMode={true}
    >
      <div className="xl:pl-14 bg-line-pattern bg-[length:600px_600px] bg-repeat border-x">
        <div className="xl:border-l xl:border-l-gray-200 ">
          <HeroOperation entry={data} />
          <div className="bg-white ">
            <div className="grid grid-cols-1 xl:grid-cols-12">
              <div className="xl:col-span-4 hidden xl:block xl:pt-12">
                <div className="sticky top-10">
                  <div className="px-16 space-y-10">
                    <PostSummary richTextDocument={data.body.json} />
                  </div>
                </div>
                {/* <p>Chiffre clés</p> */}
              </div>
              <div className="xl:col-span-8 xl:border-l px-6 py-16 xl:py-12 xl:px-16">
                <div
                  {...ContentfulLivePreview.getProps({
                    entryId: entry.sys.id,
                    fieldId: "body",
                  })}
                >
                  <RichTextOperation
                    richTextDocument={data.body.json}
                    links={data.body.links}
                    keyIndicators={data.keyIndicators?.list}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentfulLivePreviewProvider>
  );
};
